import { render, staticRenderFns } from "./SalesPersonDisplayView.vue?vue&type=template&id=5cf3bed5"
import script from "./SalesPersonDisplayView.vue?vue&type=script&lang=js"
export * from "./SalesPersonDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports